import React from 'react';
import Select, { components } from 'react-select';
import { FlexRow } from '@make-software/cspr-design';
import { AppsFiltersStyles } from 'app/components/common/common-styles';
import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';
import { CategoriesDropdownList } from 'app/components/common/categories/category-dropdown';
import { CategoryTag } from 'app/components/common/categories/category-tag';

export const MarketplaceCategoriesAdapter: FilterAdapter<string[]> = {
  key: 'categories',
  fromUrl: (sp) => {
    const raw = sp.get('categories');
    if (!raw) return null;
    const arr = raw.split(',').map((s) => s.trim()).filter(Boolean);
    return arr.length ? arr : null;
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value || value.length === 0) {
      next.delete('categories');
    } else {
      next.set('categories', value.join(','));
    }
    return next;
  },
  toKey: (v) => `cats:${v && v.length ? [...v].sort().join(',') : 'all'}`
};

const CustomMultiValue = (props: any) => <CategoryTag name={props.data.label} />;

const CustomOption = (props: any) => {
  const { data, isSelected, innerRef, innerProps } = props;
  return (
    <FlexRow gap={8} ref={innerRef} {...innerProps} align={'center'} style={{ paddingTop: '4px' }}>
      <CategoryTag name={data.label} />
      {isSelected && <components.MultiValueRemove {...props}>×</components.MultiValueRemove>}
    </FlexRow>
  );
};

export const MarketplaceCategoriesFilter = () => {
  const ctl = useUrlFilterController();
  const selected = (ctl.get(MarketplaceCategoriesAdapter) ?? [])
    .map((v) => CategoriesDropdownList.find((o) => o.value === v))
    .filter(Boolean);

  return (
    <Select
      isMulti
      isClearable
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      isSearchable={false}
      styles={AppsFiltersStyles()}
      options={CategoriesDropdownList}
      value={selected}
      placeholder="All categories"
      components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
      onChange={(opts) => {
        const names = (opts ?? []).map((o: any) => o.value);
        ctl.set(MarketplaceCategoriesAdapter, names.length ? names : null);
      }}
    />
  );
};
